declare function require(name: string);

/* tslint:disable:no-var-requires no-var-keyword */
const telstraLogo = require('./telstra-logo-blue.svg');
const noAccountError = require('./No_account_error.svg');
const noAccountGirl = require('./No_account_girl.svg');
const welcomeBoxStatic = require('./Welcome_Box.svg');
const connectedWorkPlace = require('./Connected_workplace_image.png');
const noConnectionSatellite = require('./NoConnection_animation.gif');
const orderSuccess = require('./Confirmation_image.png');
const errorScreen = require('./Error_Screen.gif');
const errorScreenMobile = require('./Error_Screen_Mobile.gif');
const tryAgainErrorImage = require('./Try_Again_Error_Image.svg'); // TODO
const tryAgainErrorImageInt = require('./Try_Again_Error_Image_Int.svg'); // TODO
const externalLink = require('./externalLink.svg');
const whatsNewModalImage = require('./WhatsNewModal.svg');
const staticWelcomeScreen = require('./Welcome_Screens.svg');
const errorIcon = require('./Error-Icon.svg');
const tickIcon = require('./Tick.svg');
const quoteCardImage = require('./Quote_Card.svg');
const covid19DesktopImage = require('./Covid_19_icon_desktop.svg');
const errorCloudStumbled = require('./Server-Error-Large.svg');
const leavingImage = require('./Leaving.svg');
const termsModalClipboard = require('./terms-clipboard.svg');
const plannedMaintenanceBannerLogo = require('./planned_maintenance_banner_logo.svg');
const noTeamsAvailable = require('./NothingToSee.svg');
const createUser = require('./create-user.gif');
const ssmMigration = require('./ssm-migration.svg');
const adaptiveMobilityMigrating = require('./mobility-migrating.svg');
const adaptiveMobilityMigrated = require('./mobility-available.svg');
const clockSkewImage = require('./clock-skew.svg');
const emptyDrawer = require('./empty-drawer.svg');
const nullEnquiries = require('./null-enquiries.png');
const newConfirmationSvg = require('./enquiry-confirmation.svg');
const authErrorImage = require('./auth-error-image.svg');
const ableDevelopmentUrl = require('../images/able-sprites.svg');

export {
    telstraLogo,
    noAccountError,
    noAccountGirl,
    staticWelcomeScreen,
    connectedWorkPlace,
    noConnectionSatellite,
    welcomeBoxStatic,
    orderSuccess,
    errorScreen,
    errorScreenMobile,
    tryAgainErrorImage,
    externalLink,
    whatsNewModalImage,
    tickIcon,
    errorIcon,
    quoteCardImage,
    covid19DesktopImage,
    errorCloudStumbled,
    leavingImage,
    termsModalClipboard,
    plannedMaintenanceBannerLogo,
    noTeamsAvailable,
    createUser,
    ssmMigration,
    adaptiveMobilityMigrating,
    adaptiveMobilityMigrated,
    tryAgainErrorImageInt,
    clockSkewImage,
    emptyDrawer,
    nullEnquiries,
    newConfirmationSvg,
    authErrorImage,
    ableDevelopmentUrl,
};
